import { z } from "zod";

import {
  EMAIL_REQUIRED_MESSAGE,
  EMAIL_MAX_LENGTH_MESSAGE,
  EMAIL_FORMAT_MESSAGE,
  PASSWORD_REQUIRED_MESSAGE,
} from "./message";
import { EMAIL_REGEX, MAX_EMAIL_LENGTH, PASSWORD_REGEX } from "./patterns";

// パスワードリセットリンク送信用スキーマ
export const sendPasswordResetLinkSchema = z.object({
  email: z
    .string({ required_error: EMAIL_REQUIRED_MESSAGE })
    .min(1, EMAIL_REQUIRED_MESSAGE)
    .max(MAX_EMAIL_LENGTH, EMAIL_MAX_LENGTH_MESSAGE)
    .regex(EMAIL_REGEX, EMAIL_FORMAT_MESSAGE),
});

// パスワードリセット用スキーマ
export const passwordResetSchema = z
  .object({
    password: z
      .string({ required_error: PASSWORD_REQUIRED_MESSAGE })
      .min(1, PASSWORD_REQUIRED_MESSAGE)
      .regex(PASSWORD_REGEX, {
        message:
          "※8～72文字の間で設定してください。<br/>※半角英字、半角数字の2種類を使用してください。<br/>【使用可能な記号 】 !\"#$%&''()-^@[;:",
      }),

    password_confirmation: z.string({ required_error: PASSWORD_REQUIRED_MESSAGE }).min(1, PASSWORD_REQUIRED_MESSAGE),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "パスワードが一致しません",
    path: ["password_confirmation"],
  });

export type SendPasswordResetLinkFormData = z.infer<typeof sendPasswordResetLinkSchema>;
export type PasswordResetFormData = z.infer<typeof passwordResetSchema>;
